// extracted by mini-css-extract-plugin
export default {"popover-item":"Item_popover-item__FZvP1","is-active":"Item_is-active__TU-rE","popover-item-icon":"Item_popover-item-icon__tcFkh"};